/**
 * Created by Mark on 18/04/2017.
 */

import SaveClass from './save-class.js';
import ClassName from './class-name.js';
import AddStudents from './add-students.js';
import ExistingStudents from './review-students.js';
import ClassSettings from './class-settings.js';
import LanguageSettings  from './language-settings.js'


if(sessionStorage.getItem("product") == "pratstart")
{
    const arr = [ClassName ,  AddStudents , ClassSettings  , SaveClass];
}
else
{
    const arr = [ClassName ,  AddStudents , ClassSettings , LanguageSettings , SaveClass];
}

export default [ClassName ,  AddStudents , ClassSettings , LanguageSettings , SaveClass];



// WEBPACK FOOTER //
// ./src/components/wizard/create-class-steps/index.js